import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import serviceUnitGeoprocessing from './serviceUnitGeoprocessingRead.action.json' with { type: 'json' }

const serviceUnitGeoprocessingReadDefinition = defineReadAutoAction(
  serviceUnitGeoprocessing,
  'serviceUnitGeoprocessing',
)

export default serviceUnitGeoprocessingReadDefinition
